<template>
  <dx-offer-intro product="b-move" />
</template>

<script>
import DxOfferIntro from '~/domains/offer/components/DX-OfferIntro'

export default {
  name: 'BMoveIntro',
  components: {
    DxOfferIntro,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  transition: 'none',
  meta: {
    isPublic: true,
    trackingId: 'dextra.unternehmensrechtsschutz.b-move.antragsstrecke',
    trackingGroup: ['rechtsschutz', 'unternehmensrechtsschutz'],
  },
  nuxtI18n: {
    paths: {
      de: '/unternehmensrechtsschutz/b-move/antragsstrecke/',
      fr: '/protection-juridique-entreprise/b-move/formulaire-de-demande/',
    },
  },
}
</script>
